// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgEntertainmentIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M20 4H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h12c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 12H4V6h16zm-10-3V9c0-.35.18-.67.47-.85s.66-.2.97-.04l4 2a1 1 0 0 1 .55.89c0 .37-.21.73-.55.89l-4 2A.997.997 0 0 1 9.99 13z" />
  </g>
);
export default SvgEntertainmentIcon;
SvgEntertainmentIcon.displayName = 'SvgEntertainmentIcon';
